<template>
<div id="customerInfoList" class="container section-container">
  <el-tabs v-model="curInfoType" @tab-click="tabChange">
    <!-- <el-tab-pane label="消费信息" name="1"></el-tab-pane> -->
    <el-tab-pane label="VIP信息" name="2"></el-tab-pane>
    <!-- <el-tab-pane label="合伙人" name="3"></el-tab-pane>
    <el-tab-pane label="短信记录" name="4"></el-tab-pane> -->
    <el-tab-pane label="维护日志" name="5"></el-tab-pane>
    <el-tab-pane label="跟进记录" name="6"></el-tab-pane>
    <el-tab-pane label="本地生活订单" name="7"></el-tab-pane>
    <!-- <el-tab-pane label="大牌拿手菜订单" name="8"></el-tab-pane> -->
  </el-tabs>

  <div class="contentView" v-if="curInfoType == '1'">
    <el-row class="lay-m-t-s lay-m-b-s inlineBlock">
      <el-col :span="4">订单总量：{{tableInfo.orderCount}}</el-col>
      <el-col :span="4">0元订单数量：{{tableInfo.orderZeroCount}}</el-col>
      <el-col :span="4">维修保养类：{{tableInfo.wbsjOrderCount}}</el-col>
      <el-col :span="4">洗车美容类：{{tableInfo.xcmrOrderCount}}</el-col>
      <el-col :span="4">快捷审车类：{{tableInfo.scsjOrderCount}}</el-col>
      <el-col :span="4">活动报名类：{{tableInfo.zthdOrderCount}}</el-col>
    </el-row>
    <el-table :data="tableData"
              key="table"
              height="280"
              style="width: 100%;">
      <el-table-column
        prop="orderSn"
        label="订单号">
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称">
      </el-table-column>
      <el-table-column
        prop="storeName"
        label="商家名称">
      </el-table-column>
      <el-table-column
        prop="goodsNum"
        min-width="50"
        label="商品数量">
      </el-table-column>
      <el-table-column
        prop="strOrderState"
        min-width="50"
        label="订单状态">
      </el-table-column>
      <el-table-column
        prop="strAddTime"
        label="下单时间">
      </el-table-column>
      <el-table-column
        class="tableOptions"
        min-width="50"
        label="操作">
        <template slot-scope="scope">
          <span class="to_able" @click="openDetail(scope.row)">详情</span>
          <el-button type="text" @click="dialogTableVisible = true" v-if="scope.row.orderState == 0">
            <span class="to_able" @click="agreetorefund(scope.row)">退款</span>
          </el-button>
          <el-button type="text" v-if="scope.row.orderState == 2">
            <span class="to_able" style="color: #B9B9B9;">退款中</span>
          </el-button>
          <br>
          <span class="to_able" @click="openWlDetail(scope.row)" v-if="scope.row.logisticsStatus == '1'">查看物流</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult">
      </el-pagination>
    </div>
  </div>

  <div class="contentView" v-if="curInfoType == '2'">
    <el-row class="lay-m-t-s lay-m-b-s alignCenter">
      <el-col :span="4">
        <el-select v-model="cur2SelectCity"
                   @change="getList()"
                   placeholder="VIP地区" clearable>
          <el-option :value="1" label="河南"></el-option>
          <el-option :value="2" label="北京"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" :offset="1">当前状态：{{'data' in searchParams2 ? searchParams2.data.vipStratus : '-'}}</el-col>
    </el-row>
    <el-table :data="tableData2"
              key="table2"
              height="260"
              style="width: 100%;">
      <el-table-column
        prop="id"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="strSource"
        label="VIP来源">
      </el-table-column>
      <el-table-column
        label="有效期">
        <template slot-scope="scope">
          {{scope.row.effectiveMonth}}个月
        </template>
      </el-table-column>
      <!-- <el-table-column
        class="tableOptions"
        min-width="40"
        label="操作">
        <template slot-scope="scope">
          <span class="to_able" @click="openDetail2(scope.row)">查看订单</span>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange2"
        @current-change="handleCurrentChange2"
        :current-page.sync="currentPage2"
        :page-sizes="[10,20,30,40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult2">
      </el-pagination>
    </div>
  </div>

  <div class="contentView" v-if="curInfoType == '3'">
    <el-row class="lay-m-b-s inlineBlock" v-if="searchParams3.data">
      <el-col :span="6">{{searchParams3.data.belongGrade}}级合伙人</el-col>
      <el-col :span="6">所属分公司：{{searchParams3.data.companyName}}</el-col>
      <el-col :span="12">加入合伙人时间：{{searchParams3.data.strActingTime}}</el-col>
    </el-row>
    <el-row class="lay-m-b-s inlineBlock" v-if="searchParams3.data">
      <el-col :span="6">渠道：{{searchParams3.data.strTagName}}</el-col>
      <el-col :span="6">邀请人：{{searchParams3.data.strInvitePeople || '-'}}</el-col>
      <el-col :span="12">累计邀请：{{searchParams3.data.inviteCount}}人</el-col>
    </el-row>
    <el-table :data="tableData3"
              key="table3"
              height="270"
              style="width: 100%;">
      <el-table-column
        prop="orderSn"
        label="订单号">
      </el-table-column>
      <el-table-column
        prop="buyerTel"
        label="客户手机号">
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称">
      </el-table-column>
      <el-table-column
        prop="payMoney"
        label="订单金额">
      </el-table-column>
      <el-table-column
        prop="payTimeStr"
        label="支付时间">
      </el-table-column>
      <el-table-column
        prop="divisionType"
        label="分账类型">
      </el-table-column>
      <el-table-column
        prop="divisionlMoney"
        label="分账金额">
      </el-table-column>
      <el-table-column
        prop="orderStateStr"
        label="订单状态">
      </el-table-column>
      <el-table-column
        prop="divisionlStateStr"
        label="分账状态">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange3"
        @current-change="handleCurrentChange3"
        :current-page.sync="currentPage3"
        :page-sizes="[10,20,30,40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult3">
      </el-pagination>
    </div>
  </div>

  <div class="contentView" v-if="curInfoType == '4'">
    <el-table :data="tableData4"
              key="table4"
              height="280"
              style="width: 100%;">
      <el-table-column
        prop="strSendTime"
        min-width="80"
        label="发送时间">
      </el-table-column>
      <el-table-column
        prop="strBusinessType"
        label="短信类型">
      </el-table-column>
      <el-table-column
        prop="content"
        min-width="150"
        label="短信内容">
      </el-table-column>
      <el-table-column
        prop="sendState"
        min-width="50"
        label="发送状态">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange4"
        @current-change="handleCurrentChange4"
        :current-page.sync="currentPage4"
        :page-sizes="[10,20,30,40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult4">
      </el-pagination>
    </div>
  </div>

  <div class="contentView" v-if="curInfoType == '5'">
    <el-table :data="tableData5"
              key="table5"
              height="280"
              style="width: 100%;">
      <el-table-column
        prop="createTime"
        min-width="80"
        label="操作时间">
      </el-table-column>
      <el-table-column
        prop="userName"
        label="操作人">
      </el-table-column>
      <el-table-column
        prop="userRole"
        label="角色">
      </el-table-column>
      <el-table-column
        prop="moduleName"
        min-width="50"
        label="修改类型">
      </el-table-column>
      <el-table-column
        prop="eventInfo"
        label="详细内容">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange5"
        @current-change="handleCurrentChange5"
        :current-page.sync="currentPage5"
        :page-sizes="[10,20,30,40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult5">
      </el-pagination>
    </div>
  </div>

  <div class="contentView" v-if="curInfoType == '6'">
      <el-button @click="addFollow"><i class="el-icon-plus"></i>添加跟进记录</el-button>
      <div style="height:300px;overflow-y:scroll;z-index:99;">
        <div class="container" v-for="(item, index0) in tableData6" :key="index0">
          <div class="container">{{item.date}}</div>
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in item.corpFollowRemarkDetailList"
              :key="index"
              :timestamp="activity.date">
              <el-card>
                <div>{{activity.time}}   操作人：{{activity.name}}  </div>
                <div class="container">跟进内容：{{activity.remarks}}</div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="sizeChange6"
          @current-change="handleCurrentChange6"
          :current-page.sync="currentPage6"
          :page-sizes="[10,20,30,40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalResult6">
        </el-pagination>
      </div>
  </div>
  <div class="contentView" v-if="curInfoType == '7' || this.curInfoType === '8'">
    <el-row class="lay-m-t-s lay-m-b-s inlineBlock">
      <el-col :span="4">订单总量：{{tableInfo2.lifeCount+tableInfo2.foodCount}}</el-col>
      <el-col :span="4">拿手菜订单总量：{{tableInfo2.foodCount}}</el-col>
      <el-col :span="4">消费频次：{{tableInfo2.consumptionCount}}</el-col>
      <el-col :span="4">客单价：{{tableInfo2.consumptionPrice}}元</el-col>
      <el-col :span="4">累计消费金额：{{tableInfo2.totalPrice}}元</el-col>
    </el-row>
    <el-table :data="localData" height="280" ref="orderTable">
      <el-table-column label="订单号" prop="orderNo" width="175" />
      <el-table-column
        label="商品名称"
        prop="goodsName"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column label="单价(元)" prop="sellingPrice" width="70" />
      <el-table-column label="数量" prop="number" width="50" />
      <el-table-column label="实付金额" prop="actualPrice" width="75" />
      <el-table-column label="状态" prop="orderStatus" width="120">
        <template slot-scope="scope">
          <div v-for="status in statusList" :key="status.id">
            <span v-if="status.id == scope.row.orderStatus">{{
              status.name
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下单服务点" v-if="this.curInfoType === '8'" prop="servicesSiteName" />
      <el-table-column label="下单时间" prop="createTime" />
      <!-- <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="orderDetails(scope.row.orderNo)"
            >详情</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeLocalChange"
        @current-change="handleLocalCurrentChange"
        :current-page.sync="currentLocalPage"
        :page-sizes="[10,20,30,40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="localTotal">
      </el-pagination>
    </div>
  </div>
  <el-dialog title="订单详情" :visible.sync="dialog.order.show" width="600px">
    <el-form label-width="120px">
      <el-form-item label="订单号:">
        {{dialog.order.orderSn}}
      </el-form-item>
      <el-form-item label="预计到店时间:">
        {{dialog.order.subscribeTime}}
      </el-form-item>
      <el-form-item label="支付时间:">
        {{dialog.order.strPayTime || '-'}}
      </el-form-item>
      <el-form-item label="支付手机号:">
        {{dialog.order.buyerTel}}
      </el-form-item>
      <el-form-item label="支付方式:">
        {{dialog.order.paymentCode || '-'}}
      </el-form-item>
      <el-form-item label="店铺优惠:">
        {{dialog.order.couponMoney}}
      </el-form-item>
      <el-form-item label="订单总价:">
        {{dialog.order.orderAmount}}
      </el-form-item>
      <el-form-item label="实付款:">
        {{dialog.order.payMoney}}
      </el-form-item>
    </el-form>
    <el-table :data="dialog.order.plusInfo"
              v-if="dialog.order.plusInfo.length > 0"
              style="width: 100%;">
      <el-table-column
        prop="extend3"
        label="plus级别">
      </el-table-column>
      <el-table-column
        prop="groupName"
        label="plus名称">
      </el-table-column>
      <el-table-column
        prop="groupDescribe"
        label="描述">
      </el-table-column>
      <el-table-column
        prop="extend2"
        label="售价">
      </el-table-column>
    </el-table>
    <el-table :data="dialog.order.goodsList"
              v-if="dialog.order.goodsList.length > 0"
              style="width: 100%;">
      <el-table-column
        prop="goods_name"
        label="商品名称">
      </el-table-column>
      <!--<el-table-column
        prop="goods_descr"
        label="商品描述">
      </el-table-column>-->
      <el-table-column
        prop="goods_count"
        label="数量">
      </el-table-column>
      <el-table-column
        prop="per_money"
        label="单价">
      </el-table-column>
      <el-table-column
        prop="busi_status"
        label="状态">
      </el-table-column>
      <el-table-column
        prop="validateStr"
        label="结束时间">
      </el-table-column>
    </el-table>
    <el-table :data="dialog.order.ticketSns"
              v-if="dialog.order.ticketSns.length > 0"
              style="width: 100%;">
      <el-table-column
        prop="ticketSn"
        label="核销码">
      </el-table-column>
      <el-table-column
        prop="storeName"
        label="核销商家">
      </el-table-column>
      <el-table-column
        prop="consumeDate"
        label="核销时间">
      </el-table-column>
    </el-table>
  </el-dialog>

  <el-dialog title="物流信息" :visible.sync="dialog.logistics.show" width="600px">
    <el-table :data="dialog.logistics.tableData"
              style="width: 100%;" v-if="dialog.logistics.tableData.length > 0">
      <el-table-column
        prop="orderSn"
        label="订单号">
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称">
      </el-table-column>
      <!--<el-table-column
        prop="detailOrderId"
        label="油卡号">
      </el-table-column>-->
      <el-table-column
        prop="name"
        label="收件人">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="联系电话">
      </el-table-column>
      <el-table-column
        prop="logisticName"
        label="物流名称">
      </el-table-column>
      <el-table-column
        prop="logisticNum"
        label="物流单号">
      </el-table-column>
      <el-table-column
        prop="busiState"
        label="订单状态">
      </el-table-column>
      <el-table-column
        prop="detailAddress"
        label="收件地址">
      </el-table-column>
    </el-table>
  </el-dialog>

  <el-dialog title="VIP购买记录" :visible.sync="dialog.vipDetail.show" width="600px">
    <el-table :data="dialog.vipDetail.tableData"
              style="width: 100%;">
      <el-table-column
        prop="orderSn"
        min-width="100"
        label="订单号">
      </el-table-column>
      <el-table-column
        prop="ext1"
        min-width="120"
        label="购买日期">
      </el-table-column>
      <el-table-column
        prop="ext2"
        min-width="80"
        label="支付方式">
      </el-table-column>
      <el-table-column
        prop="vehNum"
        min-width="80"
        label="支付金额">
      </el-table-column>
    </el-table>
  </el-dialog>
  <el-dialog title="填写退款金额" :visible.sync="dialogTableVisible">
      <div class="Paymentamount">支付金额：{{payMoney}}元</div>
      <div class="Paymentamount">支付方式：{{paymentCode}}</div>
      <el-form :inline="true" :model="searchParams" class="oias">
        <el-form-item label="实际退款金额：" style="width: 100%;">
          <el-input v-model="activity.productName" style clearable></el-input>
        </el-form-item>
        <el-form-item label="退款原因：" style="width: 100%;">
          <el-input v-model="activity.productreason" style clearable></el-input>
        </el-form-item>
        <el-form-item class="oias">
          <el-button type="primary" @click="Refundconfirmation">确定</el-button>
        </el-form-item>
      </el-form>
  </el-dialog>
    <!-- <el-dialog title="拒绝退款" :visible.sync="Refusetorefund">
      <el-form :inline="true" :model="searchParams" class="oias">
        <el-form-item label style>
          <el-input v-model="activity.failReason" style="width: 400px;" placeholder="请输入拒绝原因，30字以内"></el-input>
        </el-form-item>
        <el-form-item style="width: 100%;">
          <el-button type="primary" @click="Refuse">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->
  <el-dialog title="跟踪记录" :visible.sync="followDialog">
      <el-input
        type="textarea"
        :autosize="{ minRows: 8, maxRows: 10}"
        placeholder="请输入要添加的跟进信息吧，添加成功后将出现在客户动态列表里~"
        v-model="newFollowContent">
      </el-input>
       <div slot="footer" class="dialog-footer">
            <el-button @click="addFollowCancel">取 消</el-button>
            <el-button type="primary" @click="addFollowSubmit">保 存</el-button>
        </div>
  </el-dialog>
    <el-dialog title="订单详情" :visible.sync="dialog.detail.show" width="600px">
        <el-form label-width="120px">
          <el-form-item label="订单号:">
            {{dialog.detail.orderNo}}
          </el-form-item>
          <el-form-item label="商品名称:">
            {{dialog.detail.goodsName}}
          </el-form-item>
          <el-form-item label="单价(元):">
            {{dialog.detail.sellingPrice}}
          </el-form-item>
          <el-form-item label="数量:">
            {{dialog.detail.number}}
          </el-form-item>
          <el-form-item label="实付金额:">
            {{dialog.detail.actualPrice}}
          </el-form-item>
          <el-form-item label="状态:">
             <div v-for="status in statusList" :key="status.id">
              <span v-if="status.id == dialog.detail.orderStatus">{{
                status.name
              }}</span>
            </div>
          </el-form-item>
          <el-form-item label="下单时间:">
            {{dialog.detail.createTime}}
          </el-form-item>
        </el-form>
      </el-dialog>
</div>
</template>

<script>
import { baseUrl, devCode } from '../../http/baseUrl';
import http from '@/api/label';
export default {
  name: 'customerInfoList',
  props: ['mobile', 'update'],
  data () {
    return {
      curInfoType: '2',
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      tableData: [],
      tableInfo: {},
      currentPage2: 1,
      totalResult2: 0,
      totalPage2: 0,
      tableData2: [],
      tableInfo2: {
        lifeCount: 0,
        foodCount: 0,
        consumptionCount: 0,
        consumptionPrice: 0,
        totalPrice: 0
      },
      currentPage3: 1,
      totalResult3: 0,
      totalPage3: 0,
      tableData3: [],
      currentPage4: 1,
      totalResult4: 0,
      totalPage4: 0,
      tableData4: [],
      currentPage5: 1,
      totalResult5: 0,
      totalPage5: 0,
      tableData5: [],
      currentPage6: 1,
      totalResult6: 0,
      // totalPage6: 0,
      tableData6: [],
      searchParams: {
        pageIndex: 0,
        pageSize: 10
      },
      searchParams2: {
        pageIndex: 1,
        pageSize: 10
      },
      searchParams3: {
        pageIndex: 0,
        pageSize: 10
      },
      searchParams4: {
        pageIndex: 0,
        pageSize: 10
      },
      searchParams5: {
        pageIndex: 1,
        pageSize: 10
      },
      searchParams6: {
        pageIndex: 1,
        pageSize: 10
      },
      searchParams7: {
        pageIndex: 1,
        pageSize: 10
      },
      dialog: {
        detail: {
          show: false
        },
        order: {
          show: false,
          type: '',
          subscribeTime: '',
          tableData: [],
          plusInfo: [],
          goodsList: [],
          ticketSns: []
        },
        logistics: {
          show: false,
          tableData: []
        },
        vipDetail: {
          show: false,
          tableData: []
        }
      },
      id: '',
      payMoney: '',
      paymentCode: '',
      activity: {
        productName: '',
        failReason: '',
        productreason: ''
      },
      dialogTableVisible: false,
      Refusetorefund: false,
      Confirmationframe: false,
      cur2SelectCity: 1, // vip记录 当前所选的vip类型
      newFollowContent: '',
      followDialog: false,
      currentLinePage: 1,
      localData: [],
      currentLocalPage: 0,
      localTotal: 0,
      localInfo: {},
      statusList: [
        { id: 101, name: '待付款' },
        { id: 201, name: '已取消' },
        { id: 203, name: '未付款已过期' },
        { id: 401, name: '待使用' },
        { id: 701, name: '已完成' },
        { id: 801, name: '售后中' },
        { id: 802, name: '已退款' },
        { id: 800, name: '服务中' },
        { id: 102, name: '待接单' },
        { id: 602, name: '已拒绝' },
        { id: 603, name: '已拒绝' },
        { id: 604, name: '已拒绝' }
      ]
    };
  },
  watch: {
    'update' () {
      // 先格式化data
      this.curInfoType = '2';
      this.currentPage = 1;
      this.totalResult = 0;
      this.totalPage = 0;
      this.tableData = [];
      this.tableInfo = {};
      this.currentPage2 = 1;
      this.totalResult2 = 0;
      this.totalPage2 = 0;
      this.tableData2 = [];
      this.tableInfo2 = {
        lifeCount: 0,
        foodCount: 0,
        consumptionCount: 0,
        consumptionPrice: 0,
        totalPrice: 0
      };
      this.currentPage3 = 1;
      this.totalResult3 = 0;
      this.totalPage3 = 0;
      this.tableData3 = [];
      this.currentPage4 = 1;
      this.totalResult4 = 0;
      this.totalPage4 = 0;
      this.tableData4 = [];
      this.currentPage5 = 1;
      this.totalResult5 = 0;
      this.totalPage5 = 0;
      this.tableData5 = [];
      this.totalResult6 = 0;
      this.tableData6 = [];
      this.searchParams = {
        pageIndex: 0,
        pageSize: 10
      };
      this.searchParams2 = {
        pageIndex: 1,
        pageSize: 10
      };
      this.searchParams3 = {
        pageIndex: 0,
        pageSize: 10
      };
      this.searchParams4 = {
        pageIndex: 0,
        pageSize: 10
      };
      this.searchParams5 = {
        pageIndex: 1,
        pageSize: 10
      };
      this.searchParams6 = {
        pageIndex: 1,
        pageSize: 10
      };
      this.dialog = {
        detail: {
          show: false
        },
        order: {
          show: false,
          type: '',
          subscribeTime: '',
          tableData: [],
          plusInfo: [],
          goodsList: [],
          ticketSns: []
        },
        logistics: {
          show: false,
          tableData: []
        },
        vipDetail: {
          show: false,
          tableData: []
        }
      };
      this.getList();
    }
  },
  created () {
    if (this.mobile) {
      this.getList();
    }
  },
  methods: {
    // 获取列表数据
    getList () {
      if (this.curInfoType === '1') {
        this.axios.all([
          this.axios.get(`/memberInfo/memberOrderList`, { params: {
            memberTel: this.mobile,
            pageIndex: this.searchParams.pageIndex,
            pageSize: this.searchParams.pageSize
          }}),
          this.axios.get(`/member/countMemberOrderQuantity`, { params: { mobile: this.mobile } })
        ])
          .then(this.axios.spread((res1, res2) => {
            if (res1.data.isSuccess) {
              this.tableData = res1.data.resultData.content;
              this.totalResult = res1.data.resultData.total;
              this.totalPage = res1.data.resultData.pageTotal;
            }
            if (res2.data.isSuccess) {
              this.tableInfo = res2.data.resultData;
            }
          }));
      } else if (this.curInfoType === '2') {
        this.axios.all([
          this.axios.get(`/memberInfo/memberVipSource`, { params: {
            memberTel: this.mobile,
            vipArea: this.cur2SelectCity,
            pageIndex: this.searchParams2.pageIndex,
            pageSize: this.searchParams2.pageSize
          }})
        ])
          .then(this.axios.spread((res1) => {
            if (res1.data.errorCode == 0) {
              this.searchParams2.data = res1.data.data;
              'vipArea' in this.searchParams2.data && (this.cur2SelectCity = this.searchParams2.data.vipArea);
              this.tableData2 = res1.data.data.vipSourceList;
              this.totalResult2 = res1.data.total;
              /* var tatalPage = Math.ceil(res1.data.total / this.searchParams2.pageSize); // 计算一下总页数
              this.totalPage2 = tatalPage; */
            }
          }));
      } else if (this.curInfoType === '3') {
        this.axios.all([
          this.axios.get(`/memberInfo/agentInfo`, { params: { memberTel: this.mobile } }),
          this.axios.get(`/memberInfo/agentOrderList`, { params: {
            memberTel: this.mobile,
            pageIndex: this.searchParams3.pageIndex,
            pageSize: this.searchParams3.pageSize
          }})
        ])
          .then(this.axios.spread((res1, res2) => {
            if (res1.data.isSuccess) {
              this.searchParams3.data = res1.data.resultData;
              this.tableData3 = res2.data.resultData.content;
              this.totalResult3 = res2.data.resultData.total;
              this.totalPage3 = res2.data.resultData.pageTotal;
            }
          }));
      } else if (this.curInfoType === '4') {
        this.axios.get(`/memberInfo/messageList`, {
          params: {
            memberTel: this.mobile,
            pageIndex: this.searchParams4.pageIndex,
            pageSize: this.searchParams4.pageSize
          }
        })
          .then(res => {
            if (res.data.isSuccess) {
              this.tableData4 = res.data.resultData.content;
              this.totalResult4 = res.data.resultData.total;
              this.totalPage4 = res.data.resultData.pageTotal;
            }
          });
      } else if (this.curInfoType === '5') {
        this.axios.get(`/memberInfo/logList`, {
          params: {
            memberTel: this.mobile,
            pageIndex: this.searchParams5.pageIndex,
            pageSize: this.searchParams5.pageSize
          }
        })
          .then(res => {
            if (res.data.errorCode == 0) {
              this.tableData5 = res.data.data;
              this.totalResult5 = res.data.total;
              var tatalPage = Math.ceil(res.data.total / this.searchParams5.pageSize); // 计算一下总页数
              this.totalPage5 = tatalPage;
            }
          });
      } else if (this.curInfoType === '6') {
        const params = {
          mobile: this.mobile,
          pageNum: this.searchParams6.pageIndex || 1,
          pageSize: this.searchParams6.pageSize || 10
        };
        http.remarkList(params).then((res6) => {
          if (res6.errorCode == 0) {
            this.tableData6 = res6.data;
            this.totalResult6 = res6.total;
          }
        });
      } else if (this.curInfoType === '7' || this.curInfoType === '8') {
        const params = {
          mobile: this.mobile,
          orderBusinessType: this.curInfoType === '7' ? 6 : 11, // 6本地生活 10上门洗车 11拿手菜
          pageNum: this.searchParams7.pageIndex,
          pageSize: this.searchParams7.pageSize
        };
        http.orderList(params).then((res) => {
          if (res.errorCode == 0) {
            /* for (let i = 0; i < res.data.length; i++) {
              let item = res.data[i];
              item.goodsName = res.data[i].goodsList ? res.data[i].goodsList[0].goodsName : '';
              item.sellingPrice = res.data[i].goodsList ? res.data[i].goodsList[0].sellingPrice : '';
            } */
            this.localData = res.data;
            this.localTotal = res.total;
          };
          // res.data.forEach((item) => {
          //   if (item.picUrl && item.picUrl.indexOf(',') !== -1) {
          //     item.picUrlShow = item.picUrl.split(',')[0];
          //   } else {
          //     item.picUrlShow = item.picUrl;
          //   }
          // });
          this.$nextTick(() => {
            this.$refs.orderTable.doLayout();
          });
        });
        http.statistics({mobile: this.mobile}).then((res) => {
          console.log('获取本地用户信息', res);
          if (res.errorCode == 0) {
            this.tableInfo2 = {
              lifeCount: res.data.lifeCount || 0,
              foodCount: res.data.foodCount || 0,
              consumptionCount: res.data.consumptionCount || 0,
              consumptionPrice: res.data.consumptionPrice || 0,
              totalPrice: res.data.totalPrice || 0
            };
          }
        });
      }
    },
    // 切换tab标签
    tabChange () {
      if (this.curInfoType === '7' || this.curInfoType === '8') {
        this.currentLocalPage = 1;
        this.searchParams7.pageIndex = 1;
        this.localTotal = 0;
        this.getList();
      } else {
        this.getList();
      }
    },
    // 每页展示的个数
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 换页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getList();
    },
    // 每页展示的个数
    sizeChange2 (val) {
      this.searchParams2.pageSize = val;
      this.searchParams2.pageIndex = 1;
      this.getList();
      this.currentPage2 = 1;
    },
    // 换页
    handleCurrentChange2 (val) {
      this.searchParams2.pageIndex = val;
      this.getList();
    },
    // 每页展示的个数
    sizeChange3 (val) {
      this.searchParams3.pageSize = val;
      this.searchParams3.pageIndex = 0;
      this.getList();
      this.currentPage3 = 1;
    },
    // 换页
    handleCurrentChange3 (val) {
      this.searchParams3.pageIndex = val - 1;
      this.getList();
    },
    // 每页展示的个数
    sizeChange4 (val) {
      this.searchParams4.pageSize = val;
      this.searchParams4.pageIndex = 0;
      this.getList();
      this.currentPage4 = 1;
    },
    // 换页
    handleCurrentChange4 (val) {
      this.searchParams4.pageIndex = val - 1;
      this.getList();
    },
    // 每页展示的个数
    sizeChange5 (val) {
      this.searchParams5.pageSize = val;
      this.searchParams5.pageIndex = 1;
      this.getList();
      this.currentPage5 = 1;
    },
    // 换页
    handleCurrentChange5 (val) {
      this.searchParams5.pageIndex = val;
      this.getList();
    },
    // 每页展示的个数
    sizeChange6 (val) {
      this.searchParams6.pageSize = val;
      this.searchParams6.pageIndex = 1;
      this.getList();
      this.currentPage6 = 1;
    },
    // 换页
    handleCurrentChange6 (val) {
      this.searchParams6.pageIndex = val;
      this.getList();
    },
    // 搜索列表
    submitSearch () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 清除列表的搜索表单
    clearListSearch () {
      this.searchParams = {
        pageIndex: 0,
        pageSize: 10
      };
      this.getList();
    },
    // 打开消费信息列表的详情
    openDetail (obj) {
      this.axios.get(`/memberInfo/memberOrderDetail`, { params: {
        orderId: obj.id
      }})
        .then(res => {
          this.dialog.order.show = true;
          this.dialog.order.buyerTel = res.data.resultData.orderDetail.buyerTel;
          this.dialog.order.orderSn = res.data.resultData.orderDetail.orderSn;
          this.dialog.order.paymentCode = res.data.resultData.orderDetail.paymentCode;
          this.dialog.order.payMoney = res.data.resultData.orderDetail.payMoney;
          this.dialog.order.orderAmount = res.data.resultData.orderDetail.orderAmount;
          this.dialog.order.couponMoney = res.data.resultData.orderDetail.couponMoney;
          this.dialog.order.strPayTime = res.data.resultData.orderDetail.strPayTime;
          this.dialog.order.plusInfo = [];
          this.dialog.order.goodsList = [];
          this.dialog.order.ticketSns = [];
          this.dialog.order.subscribeTime = res.data.resultData.ticketSns[0].subcribeTimeStr;
          if ('plusInfo' in res.data.resultData) {
            this.dialog.order.plusInfo[0] = res.data.resultData.plusInfo;
          }
          if ('goodsList' in res.data.resultData) {
            this.dialog.order.goodsList = res.data.resultData.goodsList;
          }
          if ('ticketSns' in res.data.resultData) {
            this.dialog.order.ticketSns = res.data.resultData.ticketSns;
          }
        });
    },
    orderDetails (orderNo) {
      http.orderDetail({orderNo: orderNo, mobile: this.mobile}).then((res) => {
        this.dialog.detail.show = true;
        this.dialog.detail.orderNo = res.data.orderNo;
        this.dialog.detail.goodsName = res.data.goodsName;
        this.dialog.detail.sellingPrice = res.data.sellingPrice;
        this.dialog.detail.number = res.data.number;
        this.dialog.detail.actualPrice = res.data.actualPrice;
        this.dialog.detail.orderStatus = res.data.orderStatus;
        this.dialog.detail.createTime = res.data.createTime;
      });
    },
    // 打开消费信息列表的物流信息
    openWlDetail (obj) {
      this.axios.get(`/memberInfo/logisticsDetail`, { params: {
        orderId: obj.id
      }})
        .then(res => {
          this.dialog.logistics.tableData[0] = [];
          this.dialog.logistics.show = true;
          this.dialog.logistics.tableData[0] = res.data.resultData;
        });
    },
    // 打开VIP信息列表的详情
    openDetail2 (obj) {
      this.axios.get(`/memberInfo/memberVipBuyRecord`, { params: {
        orderSn: obj.sourceId
      }})
        .then(res => {
          this.dialog.vipDetail.show = true;
          this.dialog.vipDetail.tableData = res.data.resultData;
        });
    },
    agreetorefund (info) {
      this.id = info.id;
      this.payMoney = info.payMoney;
      this.activity.productName = '';
      this.activity.productreason = '';
      this.paymentCode = info.paymentCode;
      if (this.paymentCode === 'wxpay') {
        this.paymentCode = '微信支付';
      } else if (this.paymentCode === 'alipay') {
        this.paymentCode = '支付宝支付';
      } else if (this.paymentCode === 'alipay') {
        this.paymentCode = '支付宝支付';
      } else if (this.paymentCode === 'ccbpay') {
        this.paymentCode = '银联支付';
      } else if (this.paymentCode === 'webwxpay') {
        this.paymentCode = 'web微信支付';
      } else if (this.paymentCode === 'online') {
        this.paymentCode = '在线支付';
      } else if (this.paymentCode === 'offline') {
        this.paymentCode = '线下支付';
      }
    },
    Refundconfirmation () {
      if (this.activity.productName <= this.payMoney) {
        if (this.activity.productName) {
          if (this.activity.productreason) {
            this.axios({
              url: 'memberInfo/updateRefundOrderState' + devCode,
              method: 'POST',
              params: {
                orderId: this.id,
                applyReason: this.activity.productreason,
                refundMoney: this.activity.productName
              },
              baseURL: baseUrl
            })
              .then(response => {
                if (response.data.isSuccess) {
                  this.$message({
                    message: '申请成功',
                    type: 'success'
                  });
                  this.getList();
                  this.dialogTableVisible = false;
                  this.activity.failReason = '';
                } else {
                  this.$message.error(response.data.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            this.$message.error('请输入退款原因');
          }
        } else {
          this.$message.error('退款金额不能为空');
        }
      } else {
        this.$message.error('退款金额不能大于支付金额');
      }
    },
    Refusetorefunds (info) {
      this.id = info.id;
    },
    addFollow () {
      this.followDialog = true;
      this.newFollowContent = '';
    },
    addFollowCancel () {
      this.followDialog = false;
      this.newFollowContent = '';
    },
    addFollowSubmit () {
      const params = {
        mobile: this.mobile,
        remarks: this.newFollowContent,
        channel: 0,
        name: sessionStorage.getItem('name'),
        userName: sessionStorage.getItem('username')
      };
      http.remarkSave(params).then((res) => {
        if (res.success) {
          this.followDialog = false;
          this.$message({message: '添加成功', type: 'success'});
          this.getList();
          this.newFollowContent = '';
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 每页展示的个数
    sizeLocalChange (val) {
      this.searchParams7.pageSize = val;
      this.searchParams7.pageIndex = 1;
      this.getList();
      this.currentLocalPage = 1;
    },
    // 换页
    handleLocalCurrentChange (val) {
      this.searchParams7.pageIndex = val;
      this.getList();
    }
    // Refuse () {
    //   if (this.activity.failReason.length <= 30) {
    //     this.axios({
    //       url: 'orderManage/updateRefundOrderState' + devCode,
    //       method: 'POST',
    //       params: {
    //         id: this.id,
    //         refundStatus: 2,
    //         failReason: this.activity.failReason
    //       },
    //       baseURL: baseUrl
    //     })
    //       .then(response => {
    //         this.$message({
    //           message: '拒绝成功',
    //           type: 'success'
    //         });
    //         this.getList();
    //         this.Refusetorefund = false;
    //         this.activity.failReason = '';
    //       })
    //       .catch(error => {
    //         console.log(error);
    //       });
    //   } else {
    //     this.$message.error('字数限制，请输入30字以内');
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
#customerInfoList{min-width: 800px; height: 469px; margin: 10px 0 0 330px;}
.container{padding: 10px;}
.contentView{padding: 0;}
.inlineBlock{display: inline-block; width: 100%;}
.alignCenter{display: flex; align-items: center;}
.el-table{background-color: transparent;}
/*.el-table th.is-leaf{border-color: transparent;}*/

.changeEditable{
& > .el-input{width: 130px;}
& > .el-select{width: 100px;}
}

.lineRight{position: absolute; right: 0; top: 0;}

.likeA{cursor: pointer; color: $theme-color-blue;
&:hover{text-decoration: underline;}}

.iconAble{margin-left: 5px; cursor: pointer; font-size: 16px;}
.edit:hover{color: $theme-color-blue;}

.el-form-item{margin-bottom: 0;}
.rBtn {
  float: none;
}
.dialog-footer {
  margin-left: 45%;
}
.cell {
  text-align: center;
}
.Paymentamount {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
.oias {
  text-align: center;
  margin-top: 10px;
}
</style>
<style>
.el-form--inline .el-form-item__label{
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/customerCheck/infoList.vue